module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_2"
    }
  }, [_c('span', [_vm._v("Wolf at First Sight")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoInd"
  }, [_vm._v("By Rhys Ford")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk132716472"
    }
  }, [_vm._v("SFPD Lieutenant Joseph Zanetti has spent years protecting his city, and from the looks of St. Connal’s Pub and its bad-boy owner, Levi Keller, the place is a hotspot for trouble and violence. Joe’s problem? Levi is delectably hot, with secrets Joe can’t wait to dig into.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("As a Peacekeeper for paranormals, wolf shifter Levi doesn’t need the complication of a hot cop sniffing around his pub when he’s just sent his teen son off to summer camp. He’s busy brokering a peace agreement between two warring factions. When Joe stumbles into Levi’s world, both plunge into a situation neither one of them was ready for—falling in love.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Cen"
  }, [_c('span', [_vm._v("To everyone who loves things that go bump in the night…")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01235b60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0